<h2 mat-dialog-title>Filter</h2>

<mat-dialog-content class="filter-dialog-content">
  <ng-template #ruleSetTemplate let-formGroup="formGroup" let-parentGroup="parentGroup" let-index="index">
    <div class="ruleset" [formGroup]="formGroup">
      <div class="ruleset-header">
        <mat-button-toggle-group formControlName="condition" aria-label="Condition">
          <mat-button-toggle value="AND">AND</mat-button-toggle>
          <mat-button-toggle value="OR">OR</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="ruleset-actions">
          <button mat-raised-button color="primary" (click)="addRule(formGroup)">Rule</button>
          <button mat-raised-button color="primary" (click)="addRuleSet(formGroup)">Rule set</button>
          <button *ngIf="parentGroup" mat-icon-button class="delete-ruleset-button" (click)="removeRule(parentGroup, index)">
             <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="getRules(formGroup).controls.length === 0 && formGroup.touched" class="validation-error">
        Please add a rule or a rule set.
      </div>
      
      <div formArrayName="rules" class="rules-container">
        <div *ngFor="let control of getRules(formGroup).controls; let i = index" class="rule-or-ruleset-container">
          <ng-container [formGroupName]="i">
            <div *ngIf="!isRuleSet(control)" class="rule">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Field</mat-label>
                <mat-select formControlName="field">
                  <mat-option *ngFor="let field of fields" [value]="field.value">
                    {{ field.viewValue }}
                  </mat-option>
                </mat-select>
                 <mat-error *ngIf="control.get('field')?.hasError('required')">Field is required</mat-error>
              </mat-form-field>
              
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Operator</mat-label>
                <mat-select formControlName="operator">
                  <mat-option *ngFor="let op of operators" [value]="op.value">
                    {{ op.viewValue }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="control.get('operator')?.hasError('required')">Operator is required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Value</mat-label>
                <input matInput formControlName="value">
                 <mat-error *ngIf="control.get('value')?.hasError('required')">Value is required</mat-error>
              </mat-form-field>

              <button mat-icon-button (click)="removeRule(formGroup, i)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>

            <ng-container *ngIf="isRuleSet(control)">
              <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: control, parentGroup: formGroup, index: i }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: queryForm, parentGroup: null, index: -1 }"></ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onApply()" [disabled]="queryForm.invalid">Apply</button>
</mat-dialog-actions>